import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Je nám ľúto, že článok nebol užitočný. Dáte nám vedieť, čo bolo zlé?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Informácie, ktoré hľadám, chýbajú',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Vyskytujú sa faktické chyby',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Niektoré otázky sú nejasné',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Daj nam trochę tła i poprawimy ten artykuł.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Wyślij'
    }
  }
};
